import {TableauEmbed} from "./TableauEmbed";

export * from './constants';

export default TableauEmbed;
